import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import StatusDot, { StatusStyle } from '../../components/Status/StatusDot';
import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { TesterItem } from './Testers.queries';

const columns: Column[] = [
  {
    id: 'status',
    header: 'Status',
    accessor: (vendor: TesterItem) => {
      let style: StatusStyle = 'default';
      switch (vendor.status) {
        case 'ACTIVE':
          style = 'success';
          break;
        case 'INACTIVE':
          style = 'error';
          break;
      }
      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (vendor: TesterItem): string => {
      return constantToLabel(vendor.status);
    },
    width: 80,
  },
  {
    header: 'Name',
    accessor: 'profile.name',
    width: 300,
  },
  {
    header: 'Account',
    accessor: 'accountNumber',
    width: 150,
  },
  {
    id: 'profile.type',
    header: 'Type',
    accessor: (row: TesterItem) => constantToLabel(row.profile.type),
    width: 120,
  },
  {
    id: 'profile.phones.value',
    header: 'Phone',
    accessor: (row: TesterItem) => row.profile?.phones?.[0]?.value,
    width: 140,
    sortable: false,
  },
  {
    id: 'profile.emails.value',
    header: 'Email',
    accessor: (row: TesterItem) => row.profile?.emails?.[0]?.value,
    width: 300,
    sortable: false,
  },
];

export default columns;
